import React from "react";
import { Link, Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Button, Card, Col, Divider, Form, Input, Row, Typography, Upload, message } from "antd";
import { IoAlbums, IoApps, IoArrowBackCircle, IoBusiness, IoClipboard, IoCloseCircle, IoGrid, IoMap, IoPeople, IoMan, IoSettings, IoIdCard, IoCalendar, IoDocument, IoBook, IoCalculator, IoReader, IoMenu, IoMaleFemale } from "react-icons/io5";
import { RiGraduationCapFill } from "react-icons/ri";

import { POST_API, POST_CATCH, getToken, getUPLOADAPI } from "../services/hello-api";

import Pageload from "../components/Pageload";
import { IoCameraOutline } from "react-icons/io5";

class MenuDadosSistema extends React.Component {

    state = { _loading: true, _navigate: false, _user: null, _menu: false }

    componentDidMount = () => {
        this.onView()
    }

    onView = () => {
        this.setState({_loading: true})
        if (getToken()) {
            POST_API('/credential/verify.php', { token: getToken() }).then(rs => rs.json()).then(res => {
                if (!res.return) {
                    this.setState({_navigate: true})
                } else {
                    this.setState({_user: res.user})
                }
            }).catch(() => POST_CATCH()).finally(() => {
                this.setState({_loading: false})
            })
        } else {
            this.setState({_navigate: true})
        }
    }

    render = ( ) => {

        const routes = [
            {title: <Typography className="page-bread active">Dados do Sistema</Typography>}
        ]

        if (this.state._navigate) return <Navigate to="/" />

        if (this.state._user === null || this.state._loading) return <Pageload />

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={24}>
                            <Breadcrumb items={routes} />
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row gutter={[16,16]}>
                        <Col xs={12} md={4}>
                            <Link to="generos">
                                <Card hoverable className="menu-card">
                                    <center><IoMaleFemale size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Gêneros</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="estadocivil">
                                <Card hoverable className="menu-card">
                                    <center><IoPeople size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Estado Civíl</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="agendastatus">
                                <Card hoverable className="menu-card">
                                    <center><IoReader size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Agenda Situação</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="agendatipo">
                                <Card hoverable className="menu-card">
                                    <center><IoMenu size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Agenda Prioridade</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

}

export default MenuDadosSistema;